export default class SetVH
{
  constructor()
  {
    this.lastZoom = '';
    this.check();
    
    window.addEventListener('resize', () => {
      this.check();
    });
  }
  
  check() {
    document.querySelector('html').removeClass(this.lastZoom)
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
    
    let zoom = Math.ceil(( window.outerWidth - 10 ) / window.innerWidth * 100);
    this.lastZoom = `zoom-${zoom}`;
    
    document.querySelector('html').addClass(`zoom-${zoom}`);
  }
}
